module.exports = __webpack_public_path__ + "static/media/Location_Book-Page35.78f9c0c9.png";